import { render, staticRenderFns } from "./Descontos.vue?vue&type=template&id=ac2b7cd8&scoped=true"
import script from "./Descontos.vue?vue&type=script&lang=js"
export * from "./Descontos.vue?vue&type=script&lang=js"
import style0 from "./Descontos.vue?vue&type=style&index=0&id=ac2b7cd8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ac2b7cd8",
  null
  
)

export default component.exports